import React from 'react';
import { SmIcon } from '@smiles/smiles-react-design-system';

type TProps = {
  name: string;
  size: 'small' | 'medium' | 'large' | 'xlarge';
  className?: string;
};

export function Icon({ size, name, className }: TProps) {
  return <SmIcon size={size} name={name} className={className} />;
}
